/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
import type { Subscriptions } from "../models/Subscriptions";
import type { SubscriptionsCreate } from "../models/SubscriptionsCreate";
import type { SubscriptionsUpdate } from "../models/SubscriptionsUpdate";

export class SubscribableAssetsService {
    /**
     * Get subscribable assets
     * This can only be done by the logged in user.
     * @param userId The unique user id which can be found in subject claim of the JWT.
     * @returns Subscriptions Successful operation
     * @throws ApiError
     */
    public static getSubscriptions(
        userId: any,
    ): CancelablePromise<Subscriptions> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/{userId}/subscriptions",
            path: {
                userId: userId,
            },
            errors: {
                401: `Unauthorised usage`,
                403: `Forbidden usage`,
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Update subscriptions
     * This will update user subscriptions.
     * @param userId The unique user id which can be found in subject claim of the JWT.
     * @param requestBody Update existing subscriptions
     * @returns void
     * @throws ApiError
     */
    public static updateSubscriptions(
        userId: any,
        requestBody?: SubscriptionsUpdate,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/users/{userId}/subscriptions",
            path: {
                userId: userId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                400: `Invalid request schema`,
                401: `Unauthorised usage`,
                403: `Forbidden usage`,
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Create subscriptions
     * This will create user subscriptions.
     * @param userId The unique user id which can be found in subject claim of the JWT or create User response.
     * @param requestBody Create subscriptions
     * @returns void
     * @throws ApiError
     */
    public static createSubscriptions(
        userId: any,
        requestBody?: SubscriptionsCreate,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/{userId}/subscriptions",
            path: {
                userId: userId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                400: `Invalid request schema`,
                401: `Unauthorised usage`,
                403: `Forbidden usage`,
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Delete subscriptions
     * This will delete all subscriptions specified on the request and ignore non-existent ones.
     * @param userId The unique user id which can be found in subject claim of the JWT.
     * @param ids Comma-separated list of subscription IDs to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteSubscriptions(
        userId: any,
        ids: any,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/users/{userId}/subscriptions",
            path: {
                userId: userId,
            },
            query: {
                ids: ids,
            },
            errors: {
                401: `Unauthorised usage`,
                403: `Forbidden usage`,
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
}
